import { render, staticRenderFns } from "./ChbModal.vue?vue&type=template&id=7f4b55e5&scoped=true"
import script from "./ChbModal.vue?vue&type=script&lang=js"
export * from "./ChbModal.vue?vue&type=script&lang=js"
import style0 from "./ChbModal.vue?vue&type=style&index=0&id=7f4b55e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b55e5",
  null
  
)

export default component.exports